



















import { Mixins, Component, Prop } from "vue-property-decorator";
import { EditorItemMixin } from "./mixins";
import { ModelEditableMixin } from "../../../system/mixins";
import { ReceptionContact, ReceptionContactDetail } from "../../../../domain/workflow/reception";
import { ReceptionTypeItem } from "../../../../domain/workflow/items";
import ReceptionContactDetailEditor from "./ReceptionContactDetailEditor.vue";

@Component({
  components: {
    ReceptionContactDetailEditor,
  }
})
export default class ReceptionContactEditor extends Mixins(EditorItemMixin, ModelEditableMixin) {
  // ModelEditableMixinに実体あり
  editingSource: ReceptionContact;

  @Prop()
  contactNameItems: ReceptionTypeItem[];

  get details(): ReceptionContactDetail[] {
    return this.editingSource.details;
  }

  set details(value: ReceptionContactDetail[]) {
    this.writeProperty((c: ReceptionContact) => c.details = value);
  }

  get note(): string {
    return this.editingSource.note;
  }

  set note(value: string) {
    this.writeProperty((c: ReceptionContact) => c.note = value);
  }

  updateDetails(index: number, value: any) {
    this.details.splice(index, 1, value);
  }
}
